/*
 * This will serve as documentation page for listing all available components in Dashify.
 */

export default {
  name: 'CoreComponentList',
  title: 'Component List',
  owner: 'System',
  solution: '',
  tags: ['components'],
  createdAt: 'Aug 9, 2023, 10:14 AM',
  updatedAt: 'Aug 9, 2023, 11:14 AM',
  spec: {
    view: [
      [
        'div',
        { className: '' },
        [
          [
            'div',
            {
              className: 'p-2 text-[24px] text-accent-content text-gray-950 dark:text-gray-0',
            },
            'List of all available Components in Dashify framework:',
          ],
          ['CartesianExample'],
        ],
      ],
    ],
  },
};
